/**
 * Карта дверей человека для расширения: какой хост открывать как кассу.
 *
 * Лента знает дверь из карандаша, расширение — нет. Список едет тем же окном,
 * что состав ленты: если расширения нет, сообщение никто не читает.
 * На сервер эти имена не уходят.
 */

export const DOORS = 'forq:doors';

export function parseDoors(data: unknown): {
  doors: Record<string, string>;
  ask?: string;
} | null {
  if (typeof data !== 'object' || data === null) return null;
  const body = data as Record<string, unknown>;
  if (body.channel !== DOORS) return null;
  if (typeof body.doors !== 'object' || body.doors === null) return null;
  const doors: Record<string, string> = {};
  for (const [venue, raw] of Object.entries(body.doors)) {
    if (typeof raw === 'string' && raw !== '') doors[venue] = raw;
  }
  const ask = typeof body.ask === 'string' && body.ask.startsWith('https://') ? body.ask : undefined;
  return { doors, ...(ask !== undefined ? { ask } : {}) };
}

export function doorsEnvelope(
  doors: Record<string, string>,
  ask?: string,
): { channel: string; doors: Record<string, string>; ask?: string } {
  return ask !== undefined ? { channel: DOORS, doors, ask } : { channel: DOORS, doors };
}
